var _path, _path2, _path3, _path4, _path5, _path6, _path7;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFlagUk(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.5021 3.44827H1.49785C0.670586 3.44827 0 4.11886 0 4.94612V15.0539C0 15.8811 0.670586 16.5517 1.49785 16.5517H18.5021C19.3294 16.5517 20 15.8812 20 15.0539V4.94612C20 4.11886 19.3294 3.44827 18.5021 3.44827Z",
    fill: "#41479B"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M19.9793 4.69852C19.8612 3.98918 19.245 3.44824 18.5021 3.44824H18.1124L11.7241 7.63367V3.44828H8.27586V7.63371L1.88758 3.44828H1.49785C0.755 3.44828 0.138789 3.98918 0.0207422 4.69855L5.48082 8.2759H0V11.7242H5.48082L0.0207422 15.3014C0.138789 16.0108 0.755 16.5517 1.49785 16.5517H1.88758L8.27586 12.3663V16.5517H11.7241V12.3663L18.1124 16.5517H18.5021C19.245 16.5517 19.8612 16.0108 19.9793 15.3014L14.5192 11.7241H20V8.27582H14.5192L19.9793 4.69852Z",
    fill: "#F5F5F5"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M11.0345 3.44827H8.96551V8.9655H0V11.0345H8.96551V16.5517H11.0345V11.0345H20V8.9655H11.0345V3.44827Z",
    fill: "#FF4B55"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M0.968516 16.4551L8.25692 11.7241H6.9902L0.360352 16.0277C0.522578 16.2171 0.731055 16.3654 0.968516 16.4551Z",
    fill: "#FF4B55"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M13.5309 11.7241H12.2642L19.3234 16.3063C19.5209 16.1766 19.6858 16.0014 19.8033 15.7956L13.5309 11.7241Z",
    fill: "#FF4B55"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M0.158203 4.27634L6.31953 8.27584H7.58625L0.604531 3.7438C0.41707 3.88334 0.263672 4.06576 0.158203 4.27634Z",
    fill: "#FF4B55"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M12.9908 8.27584L19.6328 3.96432C19.4688 3.77561 19.2587 3.62811 19.0196 3.5401L11.7241 8.27584H12.9908Z",
    fill: "#FF4B55"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFlagUk);
export default __webpack_public_path__ + "static/media/flag-uk.a48f622979c640130ca71a2f261c3e6b.svg";
export { ForwardRef as ReactComponent };